module.exports = __webpack_public_path__ + "static/img/banner3.abc9925b.png";